import { render, staticRenderFns } from "./IcoCheckPurple.vue?vue&type=template&id=56c0ab48&lang=html"
import script from "./IcoCheckPurple.vue?vue&type=script&lang=js"
export * from "./IcoCheckPurple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports